import { IStateAuth } from '@models/state-auth';
import {
  INIT_AUTH,
  INIT_AUTH_REQUEST,
  LOGIN_REQUEST,
  LOGIN_WITH_EMAIL,
  LOGOUT,
  LOGOUT_REQUEST,
} from '../actions';

const noLogin = {
  user: null,
  idToken: null,
  isEmailLogin: false,
};

const noError = {
  errorCode: null,
  errorMessage: null,
};

const initializeState: IStateAuth = {
  initialized: false,
  isRequesting: false,
  ...noLogin,
  ...noError,
  user: null,
  uid: null,
};

export function auth(state = initializeState, action): IStateAuth {
  const initialized = true;
  let isRequesting = false;
  switch (action.type) {
    case INIT_AUTH_REQUEST:
    case LOGIN_REQUEST:
    case LOGOUT_REQUEST: {
      isRequesting = true;
      return {
        ...state,
        ...noLogin,
        ...noError,
        isRequesting,
      };
    }
    case INIT_AUTH: {
      const { user, idToken } = action;
      return {
        ...state,
        ...noError,
        initialized,
        isRequesting,
        user,
        idToken,
      };
    }
    case LOGIN_WITH_EMAIL: {
      if (action.error) {
        const errorCode = action.error.code;
        const errorMessage = action.error.message;
        return {
          ...state,
          ...noLogin,
          initialized,
          isRequesting,
          errorCode,
          errorMessage,
        };
      }
      if (action.result) {
        const { user, idToken } = action.result;
        return {
          ...state,
          ...noError,
          initialized,
          isRequesting,
          user,
          idToken,
          isEmailLogin: true,
        };
      }
      break;
    }
    case LOGOUT: {
      if (action.error) {
        const errorCode = action.error.code;
        const errorMessage = action.error.message;
        return {
          ...state,
          ...noLogin,
          initialized,
          isRequesting,
          errorCode,
          errorMessage,
        };
      }
      return {
        ...state,
        ...noLogin,
        ...noError,
        initialized,
        isRequesting,
      };
    }
    default:
      break;
  }
  return state;
}
